import { useMemo } from 'react'

import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import { Loader } from '@/components/Loader/Loader'
import { Table } from '@/components/Table/Table'
import { Text } from '@/components/Text/Text'

import { useAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaire } from '@/__generated__/queries'
import type { FinancialAnswer } from '@/__generated__/requests'

export function FinancialAnswers({ userId }: { userId: number }) {
  const { data, isLoading } =
    useAdvisorsServiceAdvisorUsersControllerGetUserQuestionnaire({
      userId,
    })

  const financialAnswers = useMemo<FinancialAnswer[]>(() => data ?? [], [data])

  const columns = [
    {
      key: 'question',
      label: 'Question',
    },
    {
      key: 'answer',
      label: 'Answer',
    },
  ]

  const formatAnswer = (answer: string) => {
    const num = Number(answer)

    if (!Number.isNaN(num) && answer.trim() !== '') {
      return num.toLocaleString('en-US')
    }

    return answer
  }

  const rows = financialAnswers.map(({ answer, question }) => [
    <Text key={`question-${question}`} variant="body_3">
      {question}
    </Text>,
    <Text key={`answer-${question}`} variant="body_3">
      {formatAnswer(answer)}
    </Text>,
  ])

  if (isLoading) return <Loader isAuthenticatedLayout />

  return (
    <ShadowBox>
      <Table columns={columns} rows={rows} />
    </ShadowBox>
  )
}
